import React, { ChangeEvent } from 'react';

import MuiSwitch from '@material-ui/core/Switch';

import styles from './AsaphSwitch.module.scss';

export interface AsaphSwitchProps {
	checked: boolean;
	disabled?: boolean;
	name?: string;
	onChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

export const AsaphSwitch = (props: AsaphSwitchProps) => {
	return (
		<MuiSwitch
			disableRipple
			classes={{
				root: styles['switch'],
				switchBase: styles['switch__base'],
				thumb: styles['switch__thumb'],
				track: styles['switch__track'],
				checked: styles['switch__base--checked'],
			}}
			{...props}
		/>
	);
};

export default AsaphSwitch;
